/**
 * Firestore access used by every service. Every session, including the public
 * demo account, reads and writes the live database; creates in owner-scoped
 * collections are stamped with the signed-in user so they show up in the
 * owner-filtered queries on web and mobile.
 */

import {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc as fsAddDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  onSnapshot,
  serverTimestamp,
  increment,
  limit,
  setDoc as fsSetDoc,
  runTransaction,
  arrayUnion,
  arrayRemove,
  startAfter,
  Timestamp,
  getAggregateFromServer,
  sum,
  count,
  deleteField
} from "firebase/firestore";
import { currentUid, isOwnerScoped } from "./ownership";
import { stampTenancy } from "./tenancy";

function withOwner(collectionName, data) {
  const uid = currentUid();
  if (!uid || !isOwnerScoped(collectionName) || !data || typeof data !== "object") return data;
  const out = stampTenancy(collectionName, { ...data });
  if (out.createdBy == null) out.createdBy = uid;
  if (out.userId == null) out.userId = uid;
  return out;
}

export async function addDoc(collRef, data) {
  return fsAddDoc(collRef, withOwner(collRef?.id, data));
}

export async function setDoc(ref, data, options) {
  if (options?.merge) return fsSetDoc(ref, data, options);
  return fsSetDoc(ref, withOwner(ref?.parent?.id, data), options);
}

export {
  collection,
  doc,
  getDocs,
  getDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  onSnapshot,
  serverTimestamp,
  increment,
  limit,
  runTransaction,
  arrayUnion,
  arrayRemove,
  startAfter,
  Timestamp,
  getAggregateFromServer,
  sum,
  count,
  deleteField
};
